import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {sampleMenuService} from "../../../services/menu-services";


const initialState = {
    sampleMenuPacksArray: [],
    idPackForBack: null,
    idPackMealForBack: null,
    idMatching: null,
    status: null,
    error: null,
    trigger: 0,
}


const getAllSampleMenuPacks = createAsyncThunk(
    'sampleMenuSlice/getAllSampleMenuPacks',
    async (_, {rejectWithValue}) => {
        try {
            return await sampleMenuService.getAll();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const sampleMenuSlice = createSlice({
    name: "sampleMenuSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
        changeId: (state, action) => {
            state.idPackForBack = action.payload;
        },
        changeIdForMeal: (state, action) => {
            state.idPackMealForBack = action.payload;
        },
        changeIdMatching: (state, action) => {
            state.idMatching = action.payload;
        }
    },
    extraReducers: builder =>
        builder
            .addCase(getAllSampleMenuPacks.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllSampleMenuPacks.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.sampleMenuPacksArray = action.payload;
            })
            .addCase(getAllSampleMenuPacks.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: sampleMenuReducer, actions} = sampleMenuSlice;
const sampleMenuActions = {
    ...actions,
    getAllSampleMenuPacks
}

export {
    sampleMenuReducer,
    sampleMenuActions
}